
import { Component, Prop, Vue } from 'vue-property-decorator';
import { ajustHeight } from "@/shared/dom.utils";
import { ProjectDocument } from "@/interfaces/project.interfaces"

@Component
export default class SAccProjectsList extends Vue {
  // Les props
  @Prop({default: []}) private projects!: ProjectDocument[]
  @Prop({default: false}) private loading!: boolean
  @Prop({default: ''}) private search!: string

  // Les propriétés
  private height: number = 400

  // Les propriétés calculées
  private get theme() {
    return this.$store.state.theme
  }

  private get filteredProjects() {
    if (this.search) {
      return this.projects.filter(p => p.name.toLowerCase().search(this.search.toLowerCase()) !== -1)
    } else {
      return this.projects
    }
  }

  // Les hooks
  public mounted() {
    window.addEventListener('resize', this.ajustHeight)
    this.$nextTick(this.ajustHeight)
  }

  public beforeDestroy() {
    window.removeEventListener('resize', this.ajustHeight)
  }

  // Les méthodes surveillées
  // Les méthodes d'instance
  private ajustHeight() {
    this.height = ajustHeight('vsacclist', 70) //`${ajustHeight('vsacclist', 70)}px`
  }

  private onSelected(item: ProjectDocument) {
    this.$emit('current', item)
  }

  // Les méthodes statiques

}
